import MealPlanView from './MealPlanView';

export default MealPlanView;
